module.exports = __webpack_public_path__ + "img/140011.534eb91b.png";